import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import BmpLayout from "../../bmp-Layout";
import { useHistory } from 'react-router-dom';
import style from '../../common-style/common-style.module.css';
import BMPReviewTable from '../../components/Table/bmp-review-table';
import Button  from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import BsciInfo from '../../components/bsci-info/bsci-info';
import PageTopInfo from '../../components/page-top-info/page-top-info';
import BrandMarketList from '../../components/brand-market-list/brand-market-list';
import CircularProgress from '@mui/material/CircularProgress';
import { getLocalStoreItem } from '../../../../helpers/localStoreHandler';
import { APPROVED, MESSAGES, REJECTED } from '../../utils/status';
import useHttp from '../../hooks/useHttp';
// import { statusCounter } from '../../utils/functions';
import BmpPortal from '../../components/portal/bmp-portal';
import { headCellsReview as headCells } from '../../utils/table-head';
import BmpModal from '../../components/Modal/Bmp-Modal';

let isInitial = true;

export default function BmpReviewSummary() {
    const brandLocale = useSelector(state => state.LocaleSelector);
    const history = useHistory();
    const {sendRequest, error } = useHttp();
    const [loadedData, setLoadedData] = useState({});
    const [isError, setIsError] = useState(null);
    const [selected, setSelected] = useState([]);
    const [modalInfo, setModalInfo] = useState({state: '', active: false }); 
    const [isLoading, setIsLoading] = useState({main: false, approve: false, reload: false});
    const [refreshData, setRefreshData] = useState(false);
    const [pendingThemeIds, setPendingThemeIds] = useState([]);
    const [snackbarState, setSnackbarState] = useState({open: false, message: '', severity: 'success'});
    // PAGINATION
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // PAGINATION
    const isLocalData = (getLocalStoreItem('bmpSelectedLocale') && JSON.parse(getLocalStoreItem('bmpSelectedLocale'))) || null;
    const info = isLocalData || brandLocale;
    const brand = info.brand.value;
    const locale = info.locale.value;
    const market = locale?.split('-')[1];
    const lang = locale?.split('-')[0];
    const hasData = Object.keys(loadedData).length > 0;
    const plural = selected.length > 1;

    const updateLoadingState = (key, value) => {
        setIsLoading(prev => ({ ...prev, [key]: value }));
    };
    
    useEffect(()=>{
        if (!refreshData) {
            return;
        }
        
        const reFetch = async() => {
            updateLoadingState('reload', true);
            try {
                const data = await sendRequest(`summary/brand/${brand}/market/${market}/lang/${lang}?pageSize=${rowsPerPage}&pageNumber=${page+1}`);
                if (data.message) {
                    throw new Error(data.message);
                }
                setLoadedData(data);
            } catch(err) {
                window.location.reload();
                console.error(err);
            }
            updateLoadingState('reload', false);
            setRefreshData(false);
        };
        reFetch();
    }, [refreshData, brand, locale, sendRequest, page, rowsPerPage]);

    useEffect(() => {
        if (!brand || !locale) {
            return history.push('/dashboard/brand-manager-portal');
        }
        let isMounted = true;
        const fecthData = async() => {
            isInitial ? updateLoadingState('main', true) : updateLoadingState('reload', true);
            try {
                const data = await sendRequest(`summary/brand/${brand}/market/${market}/lang/${lang}?pageSize=${rowsPerPage}&pageNumber=${page+1}`);
                if (isMounted) {
                    setLoadedData(data.message ? {} : data);
                    setIsError(data.message || null);
                }
            } catch (err) {
                setLoadedData({});
                console.error(err);
            }
            isInitial ? updateLoadingState('main', false) : updateLoadingState('reload', false);
            isInitial = false;
        };
        fecthData();
        return () => {
            isMounted = false; // Cleanup function to set flag to false
        };
    }, [sendRequest, brand, locale, history, page, rowsPerPage]);

    const handleOpenModal = (state) => {
        if (state === 'approve') {
            const newPendingThemeIds = [];
            const filterItem = selected.filter(item => {
                const themes = item.skuSummary.themes;
                const isApproved = themes.find(theme => theme.content_status === APPROVED);
                const isRejected = themes.filter(theme => theme.content_status === REJECTED).length;
                if (isRejected === themes.length) {
                    return false;
                }
                if (typeof isApproved === 'object') {
                    return false;
                }
                newPendingThemeIds.push(item.doc_id);
                return true;
            });
            setPendingThemeIds(newPendingThemeIds);

            // if (isThemesValid(filteredData)) {
            if (filterItem.length) {
                setSnackbarState(prev => ({
                    ...prev,
                    open: true,
                    message: 'Please review the themes currently in pending review status.',
                    severity: 'error'
                }));
            } else {
                setModalInfo(prev => ({
                    ...prev,
                    active: true,
                    state
                }));
            }
        } else {
            setModalInfo(prev => ({
                ...prev,
                active: true,
                state
            }));
        }
    }

    
    const confirmAction = async() => {
        const data = selected.map(item => {
            // const {subCollection_uid, summary_id} = item.skuSummary;
            return {
                doc_id: item.doc_id,
                subCollection_uid: item.skuSummary.subCollection_uid,
                action: modalInfo.state,
                summary_id: item.skuSummary.summary_id,
                locale,
            }
        });
        updateLoadingState('approve', true);
        try {
            const response = await sendRequest('summary/update', 'POST', data);
            if (response && response[0].status === 500) {
                throw new Error(response[0].message);
            }
            setRefreshData(true);
            setSnackbarState(prev => ({
                ...prev,
                open: true,
                message: `Item ${modalInfo.state === 'approve' ? 'Approved' : 'Rejected'} successfully!`,
                severity: 'success'
            }));
        } catch(err) {
            setSnackbarState(prev => ({
                ...prev,
                open: true,
                message: err.message || MESSAGES.dataFailed,
                severity: 'error'
            }));
            console.error(err);
        }
        updateLoadingState('approve', false);
        setModalInfo(prev => ({
            ...prev,
            active: false
        }));
    }

    // const handleSelected = (item) => {
    //     setSelected(item);
    // }

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState(prev => ({
            ...prev,
            open: false
        }))
    };

    // const status_counts = statusCounter(loadedData?.data, 'skuSummary');

    // console.log(pendingThemeIds);

    return (
        <BmpLayout>
            {isLoading.main && (
                <div className={style.loader}>
                    <CircularProgress />
                </div>
            )} 

            {isLoading.reload && (
                <BmpPortal />
            )}

            {!isLoading.main && (
                <div className={style['main-container']}>
                    <div className={style['main-container-inner']}>
                    
                        <BrandMarketList />

                        {(error || isError) && (
                            <Alert severity="error" sx={{marginTop: '30px'}}>
                                <AlertTitle>Error</AlertTitle>
                                {error || isError}
                            </Alert>
                        )}
                        {!error && !isError && !hasData && !isLoading.reload && (
                            <Alert severity="info" sx={{marginTop: '30px'}}>
                                No data found!
                            </Alert>
                        )}
                        {!error && !isError && hasData && (
                            <>
                                <PageTopInfo 
                                    currentDate={loadedData?.generation_date?.current_generation_date || ''} 
                                    nextDate={loadedData?.generation_date?.next_generation_date || ''}
                                    totalApproved={loadedData?.totalApproved || 0}
                                    totalPending={loadedData?.totalPending || 0}
                                    totalRejected={loadedData?.totalRejected || 0}
                                    title="Auto-Generated Review Summary & Theme Explorer" 
                                    lastUpdate={loadedData?.lastActivity}
                                />
                                
                                <BMPReviewTable 
                                    headCells={headCells} 
                                    loadedData={loadedData}
                                    selected={selected}
                                    setSelected={setSelected}
                                    refreshData={refreshData}
                                    setRefreshData={setRefreshData}
                                    pendingThemeIds={pendingThemeIds}
                                    setPendingThemeIds={setPendingThemeIds}
                                    locale={locale}
                                    setSnackbarState={setSnackbarState}
                                    page={page}
                                    setPage={setPage}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={setRowsPerPage}
                                />

                                <div className={style.tableActions}>
                                    <Button onClick={() => handleOpenModal('approve')} variant="contained" color="success" disabled={!selected.length}>Approve</Button>
                                    <Button onClick={() => handleOpenModal('reject')} variant="outlined" color="error" disabled={!selected.length}>Reject</Button>
                                </div>
                                
                                <BsciInfo />
                            </>
                        )}

                    </div>
                </div>
            )}

            {modalInfo.active && (
                <BmpModal 
                    modalInfo={modalInfo} 
                    setModalInfo={setModalInfo} 
                    confirmAction={confirmAction} 
                    loading={isLoading.approve} 
                    plural={plural} 
                >
                    {selected.map(item => {
                        return (
                            <Typography key={item.sku_id} sx={{ mt: 1 }}>
                                <span 
                                    style={{
                                        paddingLeft: '3px', 
                                        paddingRight: '3px', 
                                        backgroundColor: modalInfo.state === 'approve' && item.skuSummary.content_status === APPROVED ? '#d9efe0' : modalInfo.state === 'reject' && item.skuSummary.content_status === REJECTED ? '#fab090' : ''
                                    }}
                                >Summary - <strong>{item.sku_id}</strong> - <span className={style['popup-title']}>{item.title}</span></span>
                            </Typography> 
                        )
                    })}
                </BmpModal>
            )}

            <Snackbar 
                open={snackbarState.open} 
                autoHideDuration={10000} 
                onClose={handleSnackClose} 
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleSnackClose}
                    severity={snackbarState.severity || 'success'}
                    variant="filled"
                    sx={{ width: '100%', whiteSpace: 'pre-wrap'}}
                >
                    {snackbarState.message && snackbarState.message.replace(/\\n/g, '\n')}
                </Alert>
            </Snackbar>

        </BmpLayout>
    )
}